<template>
    <div>
      <b-row>
        <b-col  sm="8">
          <b-row>
        <b-col>
        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="success"
          :statistic="'$'+stats.CH"
          statistic-title="中文"
        />
      </b-col>
      <b-col>

        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="success"
          :statistic="'$'+stats.EN"
          statistic-title="英文"
        />
      </b-col>
      <b-col>
        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="success"
          :statistic="'$'+stats.MATH"
          statistic-title="數學"
        />
      </b-col>
    </b-row>
          <b-card>
       <b-row>
         <b-col
           cols="12"
           md="2"
           class="align-items-center justify-content-start mb-1 mb-md-0"
         >
          {{ this.earn }}
         </b-col>
         <b-col
           cols="12"
           md="5"
           class="align-items-center justify-content-start mb-1 mb-md-0"
         >
       </b-col>
       
         <b-col
           cols="12"
           md="5"
         >    
           <div class="d-flex align-items-center justify-content-end">           
             <flat-pickr
             v-model="rangeDate"
             class="form-control mb-1 mr-1"
             :config="{ mode: 'range'}"
           />
             <b-button
               variant="primary"
               class="mb-1"
               @click="exportToExcel()"
             >
               <span class="text-nowrap">Export</span>
             </b-button>
           </div>
         </b-col>
       </b-row>
       <!-- <b-row>
         <b-col
        
       >
         <statistic-card-horizontal
           icon="TrendingUpIcon"
           color="success"
           :statistic="stats.total_invoice"
           statistic-title="Pending Amount"
         />
       </b-col>
       <b-col
       
       >
         <statistic-card-horizontal
           icon="DollarSignIcon"
           :statistic="'$'+stats.total_amount"
           statistic-title="Pending"
         />
       </b-col>
       <b-col
        
       >
         <statistic-card-horizontal
           icon="TargetIcon"
           color="warning"
           :statistic="'$'+stats.total_commission"
           statistic-title="Calculation"
         />
       </b-col>
     </b-row> -->
       <!-- table -->
       <b-table
         ref="selectableTable"
         :items="items"
         :fields="fields"
         responsive
         striped
         class="mb-0"
         @row-selected="onRowSelected"
       >
       <template #cell(result)="data">
        <b-badge v-if="data.item.result == 'SUCCESS'" :variant="data.item.result.toLowerCase()">
          {{ data.item.result }}
        </b-badge>
        <b-badge v-if="data.item.result == 'REFUNDED'" variant="primary">
          {{ data.item.result }}
        </b-badge>
      </template>
       </b-table>
       </b-card>
       </b-col>
             <b-col sm="4">
             <b-card>
      <b-list-group>

      <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="c in classes" :key="c.zh_name" >
        <span>{{c.name}}</span>
        
        <b-badge
          variant="primary"
          pill
          class="badge-round"
          
        >
          {{ '$'+c.total }}
        </b-badge>
      </b-list-group-item>
  
    
    </b-list-group>
  </b-card>
 
             </b-col>

       </b-row>
   
     </div>
   </template>
   
   <script>
   import BCardCode from '@core/components/b-card-code/BCardCode.vue'
   
   import vSelect from 'vue-select'
   import Ripple from 'vue-ripple-directive'
   import flatPickr from 'vue-flatpickr-component'
   import moment from 'moment'
   import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
   import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
   import {
    BListGroup, BListGroupItem,  BTable, BCard, BAvatar, BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
   export default {
     components: {
       moment,
       BListGroup, BListGroupItem,
       flatPickr,
       BTable,
       ToastificationContent,
       StatisticCardHorizontal,
       BModal, VBModal,
       BAvatar,
       BCard,
       BBadge,
       BRow,
       BCol,
       BFormGroup,
       BFormSelect,
       BPagination,
       BInputGroup,
       BFormInput,
       BInputGroupAppend,
       BInputGroupPrepend,
       BButton,
       BPagination,
       BCardCode,
       BTable,
       BButton,
       BFormGroup,
       BAvatar,
       BCardBody,
       BBadge,
       vSelect,
     },
     directives: {
       Ripple,
     },
     data() { 
       return {
         iframe_src : '//cloudfit.pro/invoice.php',
         rangeDate: null,
         searchString: null,
         type:'all',
         selected_user:null,
         earn: null,
         test_string : null,
         classes:[],
         stats: {
             CH:0 ,
             EN:0 ,
             MATH:0
         },
         headerTitle: [],
         headerVal: [],
         users:[],
         isAddNewMemberSidebarActive: false,
         searchString: null,
         perPage: 10,
         startRow: 1,
         endRow: 10,
         totalAmount: 0,
         pageOptions: [10, 15, 20],
         totalRows: 1,
         currentPage: 1,
         fields: [],
         /* eslint-disable global-require */
         items: [],
         /* eslint-disable global-require */
         status: [{
           1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
         },
         {
           1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
         }],
         selectMode: 'single',
         selected: [],
       }
     },
     watch: {
        
       rangeDate : {
         handler(newValue, oldValue) {
           this.get_data()
         },
       },
       currentPage: {
         handler(newValue, oldValue) {
           this.get_data()
         },
       },
       searchString: {
         handler(newValue, oldValue) {
           // console.log("search")
           this.searchString = newValue.toUpperCase()
           this.handleSearch()
         },
       },
       perPage: {
         handler(newValue, oldValue) {
           if (newValue < 9) {
             this.perPage = 10
           }
           // console.log("search")
           this.handleSearch()
         },
       },
     },
     created() {
       this.get_data()
     },
     methods: {
      
       
       exportToExcel() {
         import('@/@core/Export2Excel').then(excel => {
           const list = this.items
   
           const data = this.formatJson(this.headerVal, list)
           console.log(data)
           excel.export_json_to_excel({
             header: this.headerTitle,
             data,
             filename: 'invoice',
             autoWidth: true,
             bookType: 'xlsx'
           })
           //this.clearFields()
         })
       },
       formatJson(filterVal, jsonData) {
         return jsonData.map(v =>
           filterVal.map(j => {
             return v[j]
           })
         )
       },
  
       get_data(searchString = null) {
         var splitted = []
         if (this.rangeDate === null) {
           splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
           splitted[1] = moment().format("YYYY-MM-DD")
           this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().format("YYYY-MM-DD")
         } else {
           splitted = this.rangeDate.split(" to ");
         }
         var diff = moment(splitted[1], 'YYYY-MM-DD').diff(moment(splitted[0], 'YYYY-MM-DD'), "days")
         if (diff > 31) {
           alert("Date range must less than 30 days")
           return
         }
         this.$http.get(process.env.VUE_APP_API_BASE+`/report/class-income/?string=`+searchString+`&from=`+splitted[0]+`&to=`+splitted[1])
           .then(res => {
             this.fields = res.data.fields
             this.headerTitle = res.data.excel_fields
             this.headerVal = res.data.excel_values
             this.items = res.data.records
             this.classes = res.data.class
             this.totalRows = this.items.length
            this.stats = res.data.kla
            // this.items.forEach((item, i) => {
            //   this.stats[item.kla] += parseInt(item.final)
            // })
           })
       },
      
       handleChangePage() {
   
       //  this.get_data()
       },
       onRowSelected(items) {
         this.selected = items[0]
         console.log(items)
         if (items[0].is_pdf == 'Y') {
           this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_'+items[0].code+'.pdf'
           console.log(this.iframe_src)
   
         } else {
         this.iframe_src = process.env.VUE_APP_API_BASE+'/invoice.php?print=n&code='+items[0].id
         }
         this.transaction_id = items[0].transaction_id
         // this.$refs['my-modal'].show()
       },
       close() {
         this.iframe_src = '//www.cloudfit.pro/invoice.php'
         this.$refs['my-modal'].hide()
       },
       selectAllRows() {
         this.$refs.selectableTable.selectAllRows()
       },
       clearSelected() {
         this.$refs.selectableTable.clearSelected()
       },
       selectThirdRow() {
         // Rows are indexed from 0, so the third row is index 2
         this.$refs.selectableTable.selectRow(2)
       },
       unselectThirdRow() {
         // Rows are indexed from 0, so the third row is index 2
         this.$refs.selectableTable.unselectRow(2)
       },
   
       handleSearch() {
         // let _print = `The user searched for: ${searching}\n`
         // this.$refs.pre.appendChild(document.createTextNode(_print))
       // this.searchString = searching
       // this.currentx = 1
       // this.get_data()
         this.searchTimeOut()
       },
       searchTimeOut() {
         if (this.timer) {
           clearTimeout(this.timer)
           this.timer = null
         }
         this.timer = setTimeout(() => {
           // your code
           this.currentPage = 1
           this.get_data(this.searchString)
         }, 500)
       },
     },
   }
   </script>
   <style lang="scss">
   @import '@core/scss/vue/libs/vue-flatpicker.scss';
   </style>
   <style lang="scss">
   .b-table-selectable{
     .feather{
       font-size: 1.3rem;
     }
   }
  .programme {
    white-space: nowrap;
        font-family: "Ubuntu Mono", monospace;
       // font-optical-sizing: auto;
        font-weight: 300;
        font-style: normal;
}
   </style>
   